import { render, staticRenderFns } from "./Makers.vue?vue&type=template&id=9073d7a0&"
import script from "./Makers.vue?vue&type=script&lang=js&"
export * from "./Makers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports